import React, { Component, createRef } from 'react';
import qs from 'query-string';
import { Redirect } from 'react-router-dom';
import { Col, Image, Row } from 'react-bootstrap';

import ByPactopia from '../ByPactopia';
import { Auth, Http } from '../../../support';
import ReCAPTCHA from 'react-google-recaptcha';
import { HaveAnAccount } from './HaveAnAccount';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ClienteExternalRegistrationMinimalForm from './components/ClienteExternalRegistrationMinimalForm';

class RegistroSinCompra extends Component {
  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    const query = qs.parse(this.props.location.search);

    this.state = {
      query,
      cupon: query.cupon || '',
      data: {},
    };

    this.recaptchaRef = createRef();
  }

  handleOnChange = (event) => {
    this.setState({
      error: undefined,
      ...event,
    });
  };

  async submit(data) {
    this.setState({
      busy: true,
    });

    try {
      let response = await Http.post('api/ext/clientes', data);

      this.logIn(response);
    } catch (error) {
      this.setState({
        error: error.data || error,
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  }

  logIn = async (response) => {
    const { access_token, cliente, empresa, ...rest } = response.data ?? {};

    const user = {
      ...rest,
      empresa: undefined,
      cliente: undefined,
      emisor: undefined,
    };

    const data = {
      token: { access_token },
      user,
      empresa: empresa || {},
      emisor: {},
      cliente: cliente || {},
    };

    await Auth.setData(data);

    this.setState({
      isLoggedIn: true,
      busy: false,
    });
  };

  handleOnSubmit = async () => {
    const token = await this.recaptchaRef.current.executeAsync();

    const { data } = this.state;
    const body = {
      ...data,
      razon_social: 'Mi empresa',
      rfc: 'XAXX010101000',
      usuario: {
        nombre: data.nombre_comercial,
        email: data.email,
        password: data.password,
      },
      cupon: this.state.cupon || undefined,
      challenge: token,
    };

    await this.submit(body);
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={error}
          onAction={() => {}}
        />
      </div>
    );
  };

  render() {
    const { isValid, isLoggedIn, busy, data, error, query } = this.state;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/app/intro' } };

      let { to } = { to: { pathname: '/app/intro' } };

      return (
        <Redirect
          to={to}
          state={from}
        />
      );
    }

    return (
      <>
        <div className="auth-content">
          <div className="avatar mt-4">
            <div className="auth-logo">
              <div className="d-flex justify-content-start">
                <Image
                  src="/img/logo.png"
                  className="auth-logo-img opacity-6"
                  fluid={true}
                />
                <p className="title text-muted">Facturotöpia</p>
              </div>
              <div>
                <p className="subtitle">Regístrate, factura, personaliza... despreocúpate.</p>
              </div>
            </div>
          </div>

          <div className="login-content">
            <ClienteExternalRegistrationMinimalForm
              data={data}
              onChange={this.handleOnChange}
            />

            <ReCAPTCHA
              size="invisible"
              ref={this.recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              onChange={this.onCaptchaChange}
            />

            <Row>
              <Col className="text-right">
                <LoadingButton
                  type="button"
                  block={true}
                  loading={busy}
                  disabled={!isValid || busy}
                  onClick={this.handleOnSubmit}
                >
                  {busy && 'Procesando...'}
                  {!busy && 'Crear mi cuenta'}
                </LoadingButton>
              </Col>
            </Row>

            <div className="pt-3">{!!error && this.renderError()}</div>
          </div>

          <HaveAnAccount tenancy={query.tenancy} />

          <ByPactopia />
        </div>
      </>
    );
  }
}

export default RegistroSinCompra;
